<template>
  <tutorial :show="showTutorial" :show-bus="showBus" :numPages="6">
    <template slot="title">
      {{ $t("components.tutorials.tutorial_favorites.title") }}
    </template>
    <template slot="text">
      {{ $t("components.tutorials.tutorial_favorites.info_1") }}
    </template>
    <template slot="image" slot-scope="modal">
      <img
        :src="localizedSource('tutorial-f03-01.png')"
        v-show="modal.page === 0"
        alt=""
      />
      <img
        :src="localizedSource('tutorial-f03-02.png')"
        v-show="modal.page === 1"
        alt=""
      />
      <img
        :src="localizedSource('tutorial-f03-03.png')"
        v-show="modal.page === 2"
        alt=""
      />
      <img
        :src="localizedSource('tutorial-f03-04.png')"
        v-show="modal.page === 3"
        alt=""
      />
      <img
        :src="localizedSource('tutorial-f03-05.png')"
        v-show="modal.page === 4"
        alt=""
      />
      <img
        :src="localizedSource('tutorial-f03-06.png')"
        v-show="modal.page === 5"
        alt=""
      />
    </template>
  </tutorial>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LocalizedImageMixin } from "@/utils/LocalizedImageMixin";
import { TutorialMixin } from "@/utils/TutorialMixin";

import Tutorial from "../layouts/Tutorial";
import Vue from "vue";
import { ProgressStepId } from "@/utils/ProgressStepId";
import { ProgressState } from "@/utils/ProgressState";

export default {
  name: "TutorialFavorites",
  mixins: [LocalizedImageMixin, TutorialMixin],
  components: {
    Tutorial
  },
  props: {
    showBus: {
      type: Vue,
      default: null
    }
  },
  data: () => ({
    showTutorial: false
  }),
  created() {
    this.checkProgression();
  },
  computed: {
    ...mapGetters("user", ["user", "hasProgress"])
  },
  methods: {
    ...mapActions("user", ["updateProgression"]),
    checkProgression() {
      let hasSeenTutorial = this.hasProgress(ProgressStepId.TutorialFavorites);
      if (!hasSeenTutorial) {
        this.showTutorial = true;
        this.updateProgression({
          key: ProgressStepId.TutorialFavorites,
          data: { state: ProgressState.Completed }
        });
      }
    }
  }
};
</script>
